export interface IDateReturn {
  success: boolean;
  validationText?: string;
  returnedDate?: Date | null;
}

interface stringDateCheckOptions {
  blankBad?: boolean;
  pastBad?: boolean;
  futureBad?: boolean;
}

/**
 * Checks and validates a date string.
 *
 * @param date - The date string or Date object to validate and format
 * @param options - Optional formatting options for the date output
 */
export const stringDateCheck = (date: string, options?: stringDateCheckOptions): IDateReturn => {
  if (date === "" && !options?.blankBad)
    return { success: true, returnedDate: null, validationText: "No date" };
  else if (date === "")
    return { success: false, returnedDate: null, validationText: "Date missing" };
  else {
    const badDate = isNaN(Date.parse(date));
    /* istanbul ignore else */
    if (badDate) return { success: false, validationText: "Invalid date" };
    const newDate = new Date(date);
    /* istanbul ignore else */
    if (options?.pastBad && newDate < new Date())
      return { success: false, validationText: "Cannot be in the past", returnedDate: newDate };
    /* istanbul ignore else */
    if (options?.futureBad && newDate > new Date())
      return { success: false, validationText: "Cannot be in the future", returnedDate: newDate };
    else return { success: true, validationText: `${newDate.toString()}`, returnedDate: newDate };
  }
};
